import { CommonModule, DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { FinxoneSelectDropdownComponent, UiComponentsModule } from '@finxone-platform/ui-components';
import { InputPriceDirective } from '../../lib/directives/input-format-price.directive';
import player from 'lottie-web/build/player/lottie_svg';
import { BaseChartDirective, provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { DragScrollComponent, DragScrollItemDirective } from 'ngx-drag-scroll';
import { provideLottieOptions } from 'ngx-lottie';
import { NgxSmartModalModule, NgxSmartModalService } from 'ngx-smart-modal';
import { CachedSrcDirective } from '../../lib/directives/cached.src.directive';
import { SafeHtmlPipe } from '../../lib/pipes/SafeHtml.pipe';

import { PasswordStrengthComponent } from '@app/finxone-web-frontend/app/Modules/shared/widgets/password-widgets/password-strength/password-strength.component';
import { PasswordComponent } from '@app/finxone-web-frontend/app/Modules/shared/widgets/password-widgets/password/password.component';
import { RecentTransactionHistoryWidgetComponent } from './recent-transaction-history-widget/recent-transaction-history-widget.component';
import { AddressHistoryComponent } from './widgets/address-history/address-history.component';
import { AddressComponent } from './widgets/address/address.component';
import { BirthdayComponent } from '@app/finxone-web-frontend/app/Modules/shared/widgets/deprecated/birthday/birthday.component';
import { ButtonWidgetComponent } from './widgets/button-widget/button-widget.component';
import { EmailComponent } from './widgets/email/email.component';
import { CustomWidgetComponent } from './widgets/custom-widget/custom-widget.component';
import { IFrameWidgetComponent } from './widgets/iframe-widget/iframe-widget.component';
import { ImageWidgetComponent } from './widgets/image-widget/image-widget.component';
import { NameComponent } from './widgets/name/name.component';
import { PhoneNumberComponent } from '@app/finxone-web-frontend/app/Modules/shared/widgets/deprecated/phone-number/phone-number.component';
import { QuestionWidgetComponent } from './widgets/question-widget/question-widget.component';
import { QuickLinksWidgetComponent } from './widgets/quick-links-widget/quick-links-widget.component';
import { TextWidgetComponent } from './widgets/text-widget/text-widget.component';

import { AccountsListingComponent } from '@app/finxone-web-frontend/app/Modules/shared/components-library/listing-components/accounts-listing/accounts-listing.component';
import { BeneficiarySelectionComponent } from '@app/finxone-web-frontend/app/Modules/shared/components-library/listing-components/beneficiary-selection/beneficiary-selection.component';
import { TransactionHistoryComponent } from '@app/finxone-web-frontend/app/Modules/shared/components-library/listing-components/transaction-history/transaction-history.component';
import { ExchangeQuoteSummaryComponent } from '@app/finxone-web-frontend/app/Modules/shared/widgets/exchange-quote-widget/exchange-quote-summary/exchange-quote-summary.component';
import { ExchangeQuoteWidgetComponent } from '@app/finxone-web-frontend/app/Modules/shared/widgets/exchange-quote-widget/exchange-quote-widget.component';
import { PaymentRefWidgetComponent } from '@app/finxone-web-frontend/app/Modules/shared/widgets/payment-ref-widget/payment-ref-widget.component';
import { NotificationListComponent } from '@app/finxone-web-frontend/app/Modules/shared/widgets/profile-widgets/notification-list-widget/notification-list.component';
import { NgxJdenticonModule } from 'ngx-jdenticon';
import { LayoutsModule } from '../layouts/layouts.module';
import { AlertHandlerComponent } from './components-library/alert-handler/alert-handler.component';
import { AmountSummaryComponent } from './components-library/amount-summary/amount-summary.component';
import { ChangePinComponent } from './components-library/change-pin/change-pin.component';
import { ConfirmDialogComponent } from './components-library/confirmation-dilog/confirmation-dialog.component';
import { CreditDebitAmountSummaryComponent } from './components-library/credit-debit-amount-summary/credit-debit-amount-summary.component';
import { CurrencyListingComponent } from './components-library/currency-listing/currency-listing.component';
import { FinxCircleButtonComponent } from './components-library/finx-circle-button/finx-circle-button.component';
import { FreezeCardComponent } from './components-library/freeze-card/freeze-card.component';
import { FrozenStripComponent } from './components-library/frozen-strip/frozen-strip.component';
import { LogoutComponent } from './components-library/logout/logout.component';
import { LostStolenComponent } from './components-library/lost-stolen/lost-stolen.component';
import { LottieAnimationComponent } from './components-library/lottie-animation/lottie-animation.component';
import { MenuWidgetComponent } from './components-library/menu-widget/menu-widget.component';
import { MonthlyExpenditureComponent } from './components-library/monthly-expenditure/monthly-expenditure.component';
import { MonthlyIncomeComponent } from './components-library/monthly-income/monthly-income.component';
import { MultiIconQuickLinkComponent } from './components-library/multi-icon-quick-link/multi-icon-quick-link.component';
import { OrderStatusComponent } from './components-library/order-status/order-status.component';
import { PaymentButtonComponent } from './components-library/payment-button/payment-button.component';
import { PopupSelectorComponent } from './components-library/popup-selector/popup-selector.component';
import { QuickLinksComponent } from './components-library/quick-links/quick-links.component';
import { ReplaceCardComponent } from './components-library/replace-card/replace-card.component';
import { SwitchNavigatorQuickLinkComponent } from './components-library/switch-navigator-quick-link/switch-navigator-quick-link.component';
import { ToggleSwitchComponent } from './components-library/toggle-switch/toggle-switch.component';
import { AccountsListingWidgetComponent } from './widgets/accounts-listing-widget/accounts-listing-widget.component';
import { AddBeneficiaryUkfpComponent } from './widgets/add-beneficiary/add-beneficiary-ukfp/add-beneficiary-ukfp.component';
import { AddBeneficiaryComponent } from './widgets/add-beneficiary/add-beneficiary.component';
import { AddCurrencyAccountWidgetComponent } from './widgets/add-currency-account-widget/add-currency-account-widget.component';
import { BeneficiarySelectionWidgetComponent } from './widgets/beneficiary-selection-widget/beneficiary-selection-widget.component';
import { CurrencyInputFieldWidgetComponent } from './widgets/currency-input-field-widget/currency-input-field-widget.component';
import { EmailVerificationComponent } from './widgets/email-verification/email-verification.component';
import { ExchangeCurrencyWidgetComponent } from './widgets/exchange-currency-widget/exchange-currency-widget.component';
import { ImportUserComponent } from './widgets/import-user/import-user.component';
import { IntlBeneficiaryAddressComponent } from './widgets/intl-beneficiary-address/intl-beneficiary-address.component';
import { KycProviderComponent } from './widgets/kyc-provider/kyc-provider.component';
import { LabelInputComponent } from './widgets/label-input/label-input.component';
import { LogoutWidgetComponent } from './widgets/logout-widget/logout-widget.component';
import { LottieAnimationWidgetComponent } from './widgets/lottie-animation-widget/lottie-animation-widget.component';
import { MultiIconQuickLinkWidgetComponent } from './widgets/multi-icon-quick-link-widget/multi-icon-quick-link-widget.component';
import { MultiRoleWidgetComponent } from './widgets/multi-role-widget/multi-role-widget.component';
import { BackButtonComponent } from './widgets/navigation/back-widget/back-widget.component';
import { ForwardButtonComponent } from './widgets/navigation/forward-widget/forward-widget.component';
import { NotificationWidgetComponent } from './widgets/notification-widget/notification-widget.component';
import { BiometricsAuthenticationWidgetComponent } from './widgets/profile-widgets/biometrics-authentication-widget/biometrics-authentication-widget.component';
import { ProfilePictureWidgetComponent } from './widgets/profile-widgets/profile-picture-widget/profile-picture-widget.component';
import { SumsubWidgetComponent } from './widgets/sumsub-widget/sumsub-widget.component';
import { AirwallexRfiWidgetComponent } from './widgets/airwallex-rfi-widget/airwallex-rfi-widget.component';
import { SwitchNavigatorQuickLinkWidgetComponent } from './widgets/switch-navigator-quick-link-widget/switch-navigator-quick-link-widget.component';

import { OverlayModule, ViewportRuler } from '@angular/cdk/overlay';
import { IntlBeneficiaryAddedComponent } from '@app/finxone-web-frontend/app/Modules/shared/widgets/intl-payments/intl-beneficiary-added/intl-beneficiary-added.component';
import { InternationalCurrencyCountryComponent } from './components-library/international-currency-country/international-currency-country.component';
import { OtpVerificationComponent } from './components-library/otp-verification/otp-verification.component';
import { UploadFileComponent } from './upload-file/upload-file.component';
import { CompanyNameWidgetComponent } from './widgets/company-name-widget/company-name-widget.component';
import { CtaButtonWidgetComponent } from './widgets/cta-buttons/cta-button-widget/cta-button-widget.component';
import { EditAddressComponent } from '@app/finxone-web-frontend/app/Modules/shared/widgets/deprecated/edit-address/edit-address.component';

import { AddToAppleWalletWidgetComponent } from '@app/finxone-web-frontend/app/Modules/shared/widgets/add-to-apple-wallet-widget/add-to-apple-wallet-widget.component';
import { FormButtonWidgetComponent } from '@app/finxone-web-frontend/app/Modules/shared/widgets/form-widgets/form-button-widget/form-button-widget.component';
import { FormWidgetComponent } from '@app/finxone-web-frontend/app/Modules/shared/widgets/form-widgets/form-widget/form-widget.component';
import { PasswordChangeComponent } from '@app/finxone-web-frontend/app/Modules/shared/widgets/password-widgets/password-change/password-change.component';
import { PasswordEnterEmailComponent } from '@app/finxone-web-frontend/app/Modules/shared/widgets/password-widgets/password-enter-email/password-enter-email-configuration.component';
import { PasswordForgotComponent } from '@app/finxone-web-frontend/app/Modules/shared/widgets/password-widgets/password-forgot/password-forgot.component';
import { CustomCurrencyPipe } from '@app/finxone-web-frontend/app/lib/pipes/custom-currency.pipe';
import { HlmAccordionModule } from '@spartan-ng/ui-accordion-helm';
import { HlmAutocompleteModule } from '@spartan-ng/ui-autocomplete-helm';
import { HlmButtonDirective } from '@spartan-ng/ui-button-helm';
import { HlmButtonGroup } from '@spartan-ng/helm/button-group';
import { HlmDatePickerModule } from '@spartan-ng/ui-date-picker-helm';
import { HlmIconModule } from '@spartan-ng/ui-icon-helm';
import { HlmInputDirective } from '@spartan-ng/ui-input-helm';
import {
  HlmTabsComponent,
  HlmTabsContentDirective,
  HlmTabsListComponent,
  HlmTabsTriggerDirective,
} from '@spartan-ng/ui-tabs-helm';
import { NgOtpInputModule } from 'ng-otp-input';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { CustomViewportRuler } from '../../lib/cdk/custom-viewport-ruler';
import { DynamicStyleDirective } from '../../lib/directives/dynamic-style.directive';
import { HorizontalUserScrollDirective } from '../../lib/directives/horizontal-user-scroll.directive';
import { LazyLoadDirective } from '../../lib/directives/lazy-load.directive';
import { CustomDatePipe } from '../../lib/pipes/custom-date.pipe';
import { FirstLetterPipe } from '../../lib/pipes/first-letter.pipe';
import { AccordionWidgetComponent } from './accordion-widget/accordion-widget.component';
import { CardNameWidgetComponent } from './card-name-widget/card-name-widget.component';
import { ChartWidgetComponent } from './chart-widget/chart-widget.component';
import { BaseOtpVerificationComponent } from './components-library/base-otp-verification/base-otp-verification.component';
import { CardComponent } from './components-library/card/card.component';
import { CommonCarouselComponent } from './components-library/common-carousel/common-carousel.component';
import { CopyShareComponent } from './components-library/copy-share/copy-share.component';
import { DateComponent } from './components-library/date/date.component';
import { FilterContainerComponent } from './components-library/filter-container/filter-container.component';
import { FinxFormActionButtonComponent } from './components-library/finx-form-button/finx-form-action-button.component';
import { FinxTagsContainerComponent } from './components-library/finx-tags-container/finx-tags-container.component';
import { IntlNewCurrencyCountryComponent } from './components-library/intl-new-currency-country-widget/intl-new-currency-country-widget.component';
import { OrgRegistrationNumberComponent } from './components-library/org-registration-number/org-registration-number.component';
import { TemplateListViewComponent } from './components-library/template-list-view/template-list-view.component';
import { CardSecretRevealComponent } from './card-secret-reveal/card-secret-reveal.component';
import { IdentityVerificationComponent } from './identity-verification/identity-verification.component';
import { ConfirmationCodeComponent } from './confirmation-code/confirmation-code-component/confirmation-code.component';
import { OverlayConfirmationComponent } from './confirmation-code/overlay-confirmation/overlay-confirmation.component';
import { PinBoxesComponent } from './confirmation-code/pin-boxes/pin-boxes.component';
import { PinPadComponent } from './confirmation-code/pin-pad/pin-pad.component';
import { DesktopListingComponent } from './desktop-listing/desktop-listing.component';
import { InputFieldWidgetComponent } from './input-field-widget/input-field-widget.component';
import { DesktopBulkPaymentListingComponent } from './payments/desktop-guest-user-listing/desktop-bulk-payment-listing.component';
import { SectionWidgetComponent } from './section-widget/section-widget.component';
import { SpacerWidgetComponent } from './spacer-widget/spacer-widget';
import { TabWidgetComponent } from './tab-widget/tab-widget.component';
import { TwoColumnWidgetComponent } from './two-column-widget/two-column-widget.component';
import { UploadFileWithPopupComponent } from './upload-file-with-popup/upload-file-with-popup.component';
import { AccountsContextDropdownWidgetComponent } from './widgets/accounts-context-dropdown-widget/accounts-context-dropdown-widget.component';
import { AccountsContextDropdownWidgetDirective } from './widgets/accounts-context-dropdown-widget/directives/accounts-context-dropdown-widget.directive';
import { AddBeneficiarySepaComponent } from './widgets/add-beneficiary/add-beneficiary-sepa/add-beneficiary-sepa.component';
import { SecondaryIdentifierComponent } from './widgets/add-beneficiary/secondary-identifier/secondary-identifier.component';
import { AddEditBeneficiaryIntlWidgetComponent } from './widgets/add-edit-beneficiary-intl-widget/add-edit-beneficiary-intl-widget.component';
import { AddToGooglePayWidgetComponent } from './widgets/add-to-google-pay-widget/add-to-google-pay-widget.component';
import { EditBeneficiaryInternationalBeneficiaryCredentialsWidgetComponent } from './widgets/beneficiary-zone-widgets/edit-intl-beneficiary/edit-beneficiary-international-beneficiary-credentials-widget/edit-beneficiary-international-beneficiary-credentials-widget.component';
import { EditBeneficiaryInternationalCurrencyCountryWidgetComponent } from './widgets/beneficiary-zone-widgets/edit-intl-beneficiary/edit-beneficiary-international-currency-country-widget/edit-beneficiary-international-currency-country-widget.component';
import { EditBeneficiaryIntlBeneficiaryAddressComponent } from './widgets/beneficiary-zone-widgets/edit-intl-beneficiary/edit-beneficiary-intl-beneficiary-address/edit-beneficiary-intl-beneficiary-address.component';
import { EditBeneficiaryIntlCurrencyCountryNewWidgetComponent } from './widgets/beneficiary-zone-widgets/edit-intl-beneficiary/edit-beneficiary-intl-currency-country-new-widget/edit-beneficiary-intl-currency-country-new-widget.component';
import { BulkPaymentAccountsListingComponent } from './widgets/bulk-payment-accounts-listing/bulk-payment-accounts-listing.component';
import { BulkPaymentHistoryListingComponent } from './widgets/bulk-payment-history-listing/bulk-payment-history-listing.component';
import { CardFreezeToggleSwitchComponent } from './widgets/card-management-v2/card-freeze-toggle-switch/card-freeze-toggle-switch.component';
import { CardPINWidgetComponent } from './widgets/card-management-v2/card-pin-widget/card-pin-widget.component';
import { CardSensitiveDetailsComponent } from './widgets/card-management-v2/card-sensitive-details/card-sensitive-details.component';
import { CardsWidgetComponent } from './widgets/card-management-v2/cards-widget/cards-widget.component';
import { ConditionalWidgetComponent } from './widgets/conditional-widget/conditional-widget.component';
import { CopyShareContentWidgetComponent } from './widgets/copy-share-content-widget/copy-share-content-widget.component';
import { CurrencySelectorWidgetComponent } from './widgets/currency-selector-widget/currency-selector-widget.component';
import { DisplayDocumentWidgetComponent } from './widgets/display-document-widget/display-document-widget.component';
import { EditBeneficiaryAddressComponent } from './widgets/edit-beneficiary-address/edit-beneficiary-address.component';
import { EditBeneficiaryComponent } from './widgets/edit-beneficiary/edit-beneficiary.component';
import { EditOrgRegistrationNumberWidgetComponent } from './widgets/edit-org-registration-number-widget/edit-org-registration-number-widget.component';
import { InternationalBeneficiaryCredentialsWidgetComponent } from './widgets/international-beneficiary-credentials-widget/international-beneficiary-credentials-widget.component';
import { InternationalBeneficiaryCredentialsComponent } from './widgets/international-beneficiary-credentials/international-beneficiary-credentials.component';
import { InternationalCurrencyCountryWidgetComponent } from './widgets/international-currency-country-widget/international-currency-country-widget.component';
import { OnboardingNextBackButtonComponent } from './widgets/onboarding-next-back-button/onboarding-next-back-button.component';
import { OtpVerificationWidgetComponent } from './widgets/otp-verification-widget/otp-verification-widget.component';
import { PaymentReasonWidgetComponent } from './widgets/payment-reason-widget/payment-reason-widget.component';
import { PaymentRequestPendingApprovalWidgetComponent } from './widgets/payment-request-pending-approval-widget/payment-request-pending-approval-widget.component';
import { RangeCalendarWidgetComponent } from './widgets/profile-widgets/range-calendar-widget/range-calendar-widget.component';
import { ResendLinksWidgetComponent } from './widgets/resend-links-widget/resend-links-widget.component';

import { ListItemComponent } from '@app/finxone-web-frontend/app/Modules/shared/components-library/listing-components/list-item/list-item.component';
import { BeneficiaryAddressWidgetComponent } from '@app/finxone-web-frontend/app/Modules/shared/widgets/add-beneficiary-v2/beneficiary-address/beneficiary-address-widget.component';
import { BeneficiaryCredentialsWidgetComponent } from '@app/finxone-web-frontend/app/Modules/shared/widgets/add-beneficiary-v2/beneficiary-credentials/beneficiary-credentials-widget.component';
import { AddressWidgetComponent } from '@app/finxone-web-frontend/app/Modules/shared/widgets/form-widgets/address-widget/address-widget.component';
import { BirthdayWidgetComponent } from '@app/finxone-web-frontend/app/Modules/shared/widgets/form-widgets/birthday-widget/birthday-widget.component';
import { NameWidgetComponent } from '@app/finxone-web-frontend/app/Modules/shared/widgets/form-widgets/name-widget/name-widget.component';
import { OnboardingButtonComponent } from '@app/finxone-web-frontend/app/Modules/shared/widgets/form-widgets/onboarding-button/onboarding-button.component';
import { PasswordWidgetComponent } from '@app/finxone-web-frontend/app/Modules/shared/widgets/password-widgets/password-widget/password-widget.component';
import { AccountListingStrategiesModule } from '../../lib/strategies/impl/account-listing-strategies/account-listing-strategies.module';
import { DynamicWidgetsComponent } from '../zones/widget-layout/dynamic-widgets/dynamic-widgets.component';
import { AccountsContextDropdownComponent } from './components-library/accounts-context-dropdown/accounts-context-dropdown.component';
import { BanksListingComponent } from './components-library/banks-listing/banks-listing.component';
import { PaymentCancellationComponent } from './components-library/payment-cancellation/payment-cancellation.component';
import { CancelPaymentsInfoComponent } from './components-library/cancel-payments-info/cancel-payments-info.component';
import { DropdownInputFieldComponent } from './input-field-widget/dropdown-input-field/dropdown-input-field.component';
import { NominatedAccountStatusComponent } from './nominated-account-status/nominated-account-status.component';
import { BeneficiaryCountryCurrencyWidgetComponent } from './widgets/add-beneficiary-v2/beneficiary-country-currency-widget/beneficiary-country-currency-widget.component';
import { BeneficiaryPaymentRailWidgetComponent } from './widgets/add-beneficiary-v2/beneficiary-payment-rail-widget/beneficiary-payment-rail-widget.component';
import { BeneficiaryTypeWidgetComponent } from './widgets/add-beneficiary-v2/beneficiary-type-widget/beneficiary-type-widget.component';
import { BanksListingWidgetComponent } from './widgets/banks-listing-widget/banks-listing-widget.component';
import { DocumentListWidgetComponent } from './widgets/document-listing-widget/document-listing-widget.component';

import { GenericCarouselWidgetComponent } from './widgets/generic-carousel-widget/generic-carousel-widget.component';

import { BrnDialog } from '@spartan-ng/brain/dialog';
import { HlmDialogImports } from '@spartan-ng/helm/dialog';
import { CardAuthenticationReviewComponent } from './card-authentication-review/card-authentication-review.component';
import { ProductsListComponent } from './components-library/listing-components/products-list/products-list.component';
import { StateDropdownComponent } from './state-dropdown/state-dropdown.component';
import { layoutDrivenCarouselComponent } from './widgets/generic-carousel-widget/layout-driven-carousel/layout-driven-carousel.component';
import { NominatedAccountSelectionWidgetComponent } from './widgets/nominated-account-selection-widget/nominated-account-selection-widget.component';
import { PasswordRulesComponent } from './widgets/password-widgets/password-rules/password-rules.component';
import { PaymentCancellationWidgetComponent } from './widgets/payment-cancellation-widget/payment-cancellation-widget.component';
import { ProductsListWidgetComponent } from './widgets/products-list-widget/products-list-widget.component';
import { CancellablePaymentsInfoWidgetComponent } from './widgets/cancellable-payments-info-widget/cancellable-payments-info-widget.component';
import { AccountRequestListComponent } from './widgets/savings-accounts-widgets/account-request-list/account-request-list.component';
import { SupportChatWidgetComponent } from './widgets/support-chat-widget/support-chat-widget.component';
import { SupportChatsListWidgetComponent } from './widgets/support-chats-list-widget/support-chats-list-widget.component';
import { TextSkeletonComponent } from './widgets/text-skeleton/text-skeleton.component';
import { TextComponent } from './widgets/text-widget/text-component/text.component';
import { ThemeSelectorWidgetComponent } from './widgets/theme-selector-widget/theme-selector-widget.component';
import { PispBanksListingComponent } from './components-library/pisp-banks-listing/pisp-banks-listing.component';
import { PispGocardlessComplianceWidgetComponent } from './widgets/pisp-gocardless-compliance/pisp-gocardless-compliance-widget.component';
import { PispBanksListingWidgetComponent } from './widgets/pisp-banks-listing-widget/pisp-banks-listing-widget.component';
import { PispCheckBillingRequestLoaderComponent } from './widgets/pisp-check-billing-request-loader-widget/pisp-check-billing-request-loader-widget.component';
import { TooltipWidgetComponent } from './widgets/tooltip-widget/tooltip-widget.component';
import { TooltipComponent } from 'libs/ui-components/src/lib/tooltip/tooltip.component';
import { CompaniesHouseSearchWidgetComponent } from './widgets/companies-house-search-widget/companies-house-search-widget.component';
import { CompaniesHouseListingWidgetComponent } from './widgets/companies-house-listing-widget/companies-house-listing-widget.component';
import { RecurringPaymentListWidgetComponent } from './widgets/recurring-payment-list-widget/recurring-payment-list-widget.component';
import { CompaniesHouseDirectorSelectionWidgetComponent } from './widgets/companies-house-director-selection-widget/companies-house-director-selection-widget.component';
import { InvitationRedirectionHandlerComponent } from './invitation-redirection-handler/invitation-redirection-handler.component';
import { CancelPaymentTemplateComponent } from './recent-transaction-history-widget/cancel-payment-template/cancel-payment-template.component';

@NgModule({
  declarations: [
    RecentTransactionHistoryWidgetComponent,
    NameComponent,
    BirthdayComponent,
    NameWidgetComponent,
    BirthdayWidgetComponent,
    PhoneNumberComponent,
    EmailComponent,
    AddressComponent,
    AddressHistoryComponent,
    AddressWidgetComponent,
    QuestionWidgetComponent,
    QuestionWidgetComponent,
    PasswordComponent,
    PasswordWidgetComponent,
    PasswordChangeComponent,
    PasswordForgotComponent,
    PasswordEnterEmailComponent,
    CustomWidgetComponent,
    PasswordStrengthComponent,
    ChartWidgetComponent,
    QuickLinksWidgetComponent,
    ResendLinksWidgetComponent,
    ButtonWidgetComponent,
    SumsubWidgetComponent,
    KycProviderComponent,
    ImportUserComponent,
    MultiRoleWidgetComponent,
    QuickLinksComponent,
    PaymentButtonComponent,
    PopupSelectorComponent,
    FreezeCardComponent,
    ReplaceCardComponent,
    ChangePinComponent,
    LostStolenComponent,
    CreditDebitAmountSummaryComponent,
    FrozenStripComponent,
    OrderStatusComponent,
    MenuWidgetComponent,
    TransactionHistoryComponent,
    CancelPaymentTemplateComponent,
    AlertHandlerComponent,
    EmailVerificationComponent,
    FinxCircleButtonComponent,
    LabelInputComponent,
    ForwardButtonComponent,
    LabelInputComponent,
    ConfirmDialogComponent,
    AddBeneficiaryComponent,
    CurrencyInputFieldWidgetComponent,
    PaymentRefWidgetComponent,
    LogoutWidgetComponent,
    LogoutComponent,
    SwitchNavigatorQuickLinkWidgetComponent,
    SwitchNavigatorQuickLinkComponent,
    DynamicWidgetsComponent,
    BeneficiarySelectionWidgetComponent,
    BeneficiarySelectionComponent,
    AddBeneficiaryUkfpComponent,
    AddBeneficiarySepaComponent,
    IntlBeneficiaryAddressComponent,
    IntlBeneficiaryAddedComponent,
    MultiIconQuickLinkWidgetComponent,
    MultiIconQuickLinkComponent,
    LottieAnimationWidgetComponent,
    ProfilePictureWidgetComponent,
    BiometricsAuthenticationWidgetComponent,
    NotificationWidgetComponent,
    ToggleSwitchComponent,
    AccountsListingWidgetComponent,
    AccountsListingComponent,
    AccountsContextDropdownWidgetComponent,
    AccountsContextDropdownComponent,
    NotificationListComponent,
    ExchangeCurrencyWidgetComponent,
    AddCurrencyAccountWidgetComponent,
    CurrencyListingComponent,
    ExchangeQuoteWidgetComponent,
    ExchangeQuoteSummaryComponent,
    InternationalCurrencyCountryComponent,
    InternationalCurrencyCountryWidgetComponent,
    InternationalBeneficiaryCredentialsWidgetComponent,
    InternationalBeneficiaryCredentialsComponent,
    UploadFileComponent,
    UploadFileWithPopupComponent,
    CompanyNameWidgetComponent,
    RangeCalendarWidgetComponent,
    EditAddressComponent,
    OtpVerificationWidgetComponent,
    OtpVerificationComponent,
    BaseOtpVerificationComponent,
    CtaButtonWidgetComponent,
    PaymentReasonWidgetComponent,
    EditBeneficiaryInternationalCurrencyCountryWidgetComponent,
    IntlNewCurrencyCountryComponent,
    EditBeneficiaryIntlCurrencyCountryNewWidgetComponent,
    EditBeneficiaryIntlBeneficiaryAddressComponent,
    EditBeneficiaryInternationalBeneficiaryCredentialsWidgetComponent,
    EditBeneficiaryComponent,
    EditBeneficiaryAddressComponent,
    BulkPaymentAccountsListingComponent,
    DesktopBulkPaymentListingComponent,
    BulkPaymentHistoryListingComponent,
    FinxFormActionButtonComponent,
    OnboardingNextBackButtonComponent,
    OnboardingButtonComponent,
    DesktopListingComponent,
    CopyShareComponent,
    CopyShareContentWidgetComponent,
    SectionWidgetComponent,
    TwoColumnWidgetComponent,
    TabWidgetComponent,
    AccordionWidgetComponent,
    CardComponent,
    CardsWidgetComponent,
    CardAuthenticationReviewComponent,
    CardFreezeToggleSwitchComponent,
    CardSensitiveDetailsComponent,
    PaymentRequestPendingApprovalWidgetComponent,
    SecondaryIdentifierComponent,
    SpacerWidgetComponent,
    FormWidgetComponent,
    ConfirmationCodeComponent,
    OverlayConfirmationComponent,
    CardSecretRevealComponent,
    IdentityVerificationComponent,
    PinBoxesComponent,
    PinPadComponent,
    CardNameWidgetComponent,
    CurrencySelectorWidgetComponent,
    TemplateListViewComponent,
    EditOrgRegistrationNumberWidgetComponent,
    OrgRegistrationNumberComponent,
    DateComponent,
    ThemeSelectorWidgetComponent,
    CommonCarouselComponent,
    DropdownInputFieldComponent,
    InputFieldWidgetComponent,
    FormButtonWidgetComponent,
    FinxTagsContainerComponent,
    FilterContainerComponent,
    DocumentListWidgetComponent,
    BeneficiaryCredentialsWidgetComponent,
    BeneficiaryTypeWidgetComponent,
    BeneficiaryAddressWidgetComponent,
    BanksListingWidgetComponent,
    BanksListingComponent,
    PispBanksListingComponent,
    PispBanksListingWidgetComponent,
    PispGocardlessComplianceWidgetComponent,
    PispCheckBillingRequestLoaderComponent,
    NominatedAccountStatusComponent,
    NominatedAccountSelectionWidgetComponent,
    PasswordRulesComponent,
    PaymentCancellationComponent,
    PaymentCancellationWidgetComponent,
    CancelPaymentsInfoComponent,
    CancellablePaymentsInfoWidgetComponent,
    GenericCarouselWidgetComponent,
    SupportChatsListWidgetComponent,
    StateDropdownComponent,
    SupportChatWidgetComponent,
    ProductsListWidgetComponent,
    CompaniesHouseSearchWidgetComponent,
    CompaniesHouseDirectorSelectionWidgetComponent,
    RecurringPaymentListWidgetComponent,
  ],
  imports: [
    AccountsContextDropdownWidgetDirective,
    DynamicStyleDirective,
    SafeHtmlPipe,
    CustomCurrencyPipe,
    FirstLetterPipe,
    CustomDatePipe,
    CachedSrcDirective,
    LazyLoadDirective,
    HorizontalUserScrollDirective,
    CommonModule,
    MatIconModule,
    InputPriceDirective,
    UiComponentsModule,
    ReactiveFormsModule.withConfig({
      warnOnNgModelWithFormControl: 'never',
    }),
    FormsModule,
    NgxSmartModalModule,
    DragScrollComponent,
    DragScrollItemDirective,
    BaseChartDirective,
    LayoutsModule,

    // Hlm modules
    HlmTabsComponent,
    HlmTabsListComponent,
    HlmTabsTriggerDirective,
    HlmTabsContentDirective,
    HlmInputDirective,
    HlmButtonDirective,
    HlmButtonGroup,
    HlmAutocompleteModule,
    HlmDatePickerModule,
    HlmAccordionModule,
    HlmIconModule,
    BrnDialog,
    ...HlmDialogImports,

    LottieAnimationComponent,
    NgxJdenticonModule,
    OverlayModule,
    NgOtpInputModule,
    PdfViewerModule,

    // standalone widgets
    FinxoneSelectDropdownComponent,
    TextComponent,
    TextWidgetComponent,
    AirwallexRfiWidgetComponent,
    BackButtonComponent,
    AddToGooglePayWidgetComponent,
    AddToAppleWalletWidgetComponent,
    AddEditBeneficiaryIntlWidgetComponent,
    BeneficiaryCountryCurrencyWidgetComponent,
    BeneficiaryPaymentRailWidgetComponent,
    ConditionalWidgetComponent,
    CardPINWidgetComponent,
    ImageWidgetComponent,
    IFrameWidgetComponent,
    MonthlyIncomeComponent,
    MonthlyExpenditureComponent,
    AmountSummaryComponent,
    DisplayDocumentWidgetComponent,
    TooltipWidgetComponent,
    TextSkeletonComponent,
    ProductsListComponent,
    CompaniesHouseListingWidgetComponent,
    AccountRequestListComponent,

    // Strategy modules
    AccountListingStrategiesModule,
    ListItemComponent,

    // carousel components
    layoutDrivenCarouselComponent,
    TooltipComponent,
    InvitationRedirectionHandlerComponent,
  ],
  exports: [
    AccountsContextDropdownWidgetDirective,
    DynamicStyleDirective,
    SafeHtmlPipe,
    CustomCurrencyPipe,
    FirstLetterPipe,
    CustomDatePipe,
    CachedSrcDirective,
    LazyLoadDirective,
    HorizontalUserScrollDirective,

    RecentTransactionHistoryWidgetComponent,
    NameComponent,
    NameWidgetComponent,
    BirthdayWidgetComponent,
    BirthdayComponent,
    PhoneNumberComponent,
    AddressComponent,
    AddressHistoryComponent,
    AddressWidgetComponent,
    QuestionWidgetComponent,

    QuestionWidgetComponent,
    PasswordComponent,
    PasswordWidgetComponent,
    PasswordChangeComponent,
    PasswordForgotComponent,
    PasswordEnterEmailComponent,
    ImageWidgetComponent,
    TextWidgetComponent,
    TextSkeletonComponent,
    TextComponent,
    IFrameWidgetComponent,
    CustomWidgetComponent,
    PasswordStrengthComponent,
    ChartWidgetComponent,
    QuickLinksWidgetComponent,
    ResendLinksWidgetComponent,
    SumsubWidgetComponent,
    AirwallexRfiWidgetComponent,
    KycProviderComponent,
    ImportUserComponent,
    MonthlyIncomeComponent,
    MonthlyExpenditureComponent,
    MultiRoleWidgetComponent,
    QuickLinksComponent,
    PaymentButtonComponent,
    PopupSelectorComponent,
    FreezeCardComponent,
    ReplaceCardComponent,
    ChangePinComponent,
    LostStolenComponent,
    AmountSummaryComponent,
    CreditDebitAmountSummaryComponent,
    FrozenStripComponent,
    OrderStatusComponent,
    MenuWidgetComponent,
    TransactionHistoryComponent,
    CancelPaymentTemplateComponent,
    AlertHandlerComponent,
    EmailVerificationComponent,
    FinxCircleButtonComponent,
    BackButtonComponent,
    ForwardButtonComponent,
    LabelInputComponent,
    ConfirmDialogComponent,
    OverlayConfirmationComponent,
    CardSecretRevealComponent,
    IdentityVerificationComponent,
    AddBeneficiaryComponent,
    IntlBeneficiaryAddressComponent,
    IntlBeneficiaryAddedComponent,
    CurrencyInputFieldWidgetComponent,
    PaymentRefWidgetComponent,
    LogoutWidgetComponent,
    LogoutComponent,
    SafeHtmlPipe,
    SwitchNavigatorQuickLinkWidgetComponent,
    SwitchNavigatorQuickLinkComponent,
    DynamicWidgetsComponent,
    BeneficiarySelectionWidgetComponent,
    BeneficiarySelectionComponent,
    MultiIconQuickLinkWidgetComponent,
    ConditionalWidgetComponent,
    MultiIconQuickLinkComponent,
    LottieAnimationWidgetComponent,
    LottieAnimationComponent,
    ProfilePictureWidgetComponent,
    BiometricsAuthenticationWidgetComponent,
    NotificationWidgetComponent,
    ToggleSwitchComponent,
    AccountsListingWidgetComponent,
    AccountsListingComponent,
    AccountsContextDropdownWidgetComponent,
    AccountsContextDropdownComponent,
    NotificationListComponent,
    ExchangeCurrencyWidgetComponent,
    AddCurrencyAccountWidgetComponent,
    CurrencyListingComponent,
    InternationalCurrencyCountryComponent,
    InternationalCurrencyCountryWidgetComponent,
    UploadFileComponent,
    UploadFileWithPopupComponent,
    CompanyNameWidgetComponent,
    RangeCalendarWidgetComponent,
    EditAddressComponent,
    OtpVerificationWidgetComponent,
    OtpVerificationComponent,
    BaseOtpVerificationComponent,
    CtaButtonWidgetComponent,
    EditBeneficiaryInternationalCurrencyCountryWidgetComponent,
    IntlNewCurrencyCountryComponent,
    EditBeneficiaryIntlCurrencyCountryNewWidgetComponent,
    EditBeneficiaryIntlBeneficiaryAddressComponent,
    EditBeneficiaryInternationalBeneficiaryCredentialsWidgetComponent,
    AddEditBeneficiaryIntlWidgetComponent,
    EditBeneficiaryComponent,
    EditBeneficiaryAddressComponent,
    BulkPaymentAccountsListingComponent,
    DesktopBulkPaymentListingComponent,
    BulkPaymentHistoryListingComponent,
    FinxFormActionButtonComponent,
    OnboardingNextBackButtonComponent,
    OnboardingButtonComponent,
    DesktopListingComponent,
    CopyShareComponent,
    CopyShareContentWidgetComponent,
    SectionWidgetComponent,
    TwoColumnWidgetComponent,
    TabWidgetComponent,
    AccordionWidgetComponent,
    CardComponent,
    CardsWidgetComponent,
    PaymentRequestPendingApprovalWidgetComponent,
    LazyLoadDirective,
    HorizontalUserScrollDirective,
    SecondaryIdentifierComponent,
    SpacerWidgetComponent,
    FormWidgetComponent,
    CardNameWidgetComponent,
    CardPINWidgetComponent,
    AddToGooglePayWidgetComponent,
    AddToAppleWalletWidgetComponent,
    CurrencySelectorWidgetComponent,
    TemplateListViewComponent,
    OrgRegistrationNumberComponent,
    EditOrgRegistrationNumberWidgetComponent,
    DateComponent,
    ThemeSelectorWidgetComponent,
    CommonCarouselComponent,
    DropdownInputFieldComponent,
    InputFieldWidgetComponent,
    FormButtonWidgetComponent,
    FinxTagsContainerComponent,
    DisplayDocumentWidgetComponent,
    DocumentListWidgetComponent,
    BeneficiaryTypeWidgetComponent,
    BeneficiaryCountryCurrencyWidgetComponent,
    BeneficiaryPaymentRailWidgetComponent,
    BeneficiaryCredentialsWidgetComponent,
    BeneficiaryAddressWidgetComponent,
    NominatedAccountSelectionWidgetComponent,
    PaymentCancellationComponent,
    PaymentCancellationWidgetComponent,
    GenericCarouselWidgetComponent,
    TooltipWidgetComponent,
    CompaniesHouseSearchWidgetComponent,
    CompaniesHouseListingWidgetComponent,
    CompaniesHouseDirectorSelectionWidgetComponent,
    RecurringPaymentListWidgetComponent,
  ],
  providers: [
    NgxSmartModalService,
    DatePipe,
    provideCharts(withDefaultRegisterables()),
    // Used to resolve: https://github.com/angular/components/issues/18890
    { provide: ViewportRuler, useClass: CustomViewportRuler },
    provideLottieOptions({
      player: () => player,
    }),
  ],
})
export class SharedModule {}
